import { Injectable } from "@angular/core";
import { ToastrComponent } from "./toastr/toastr.component";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ToastService } from "../../services/toast.service";

@Injectable({ providedIn: "root" })
export class Misc {
  constructor(private toast: ToastService) { }

  checkFieldSize(value: string, size: number, $event: Event) {
    if (value) {
      if (value.toString().length >= size) {
        $event.preventDefault();
      }
    }
  }

  somenteNumero(e: KeyboardEvent, decimal: boolean = false) {
    const tecla = e.keyCode;

    if (tecla > 47 && tecla < 58) {
      return true;
    } else {
      if (
        tecla === 8 ||
        tecla === 0 ||
        tecla === 188 ||
        tecla === 190 ||
        (decimal && tecla === 46)
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  allowCharacter(e: KeyboardEvent) {
    const key = e.keyCode;

    return (
      (key > 64 && key < 91) ||
      (key > 96 && key < 123) ||
      key === 8 ||
      key === 32 ||
      (key >= 48 && key <= 57)
    );
  }

  processError(error: any, message = "") {
    let errorMessage = "";
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) errorMessage = "Erro desconhecido!";
      else if (error.status === 404) errorMessage = "Serviço não encontrado/indisponível!";
      else if (error.status === 400) errorMessage = "Requisição mal formada!";
      else if (error.status === 500) errorMessage = "Erro no servidor!";
    }
    if (!errorMessage) errorMessage = error?.error?.text ?? error;
    if (message) errorMessage = message + " " + errorMessage;
    if (!environment.production) console.log(error);

    this.toast.show("erro", "Erro", errorMessage, 5000);
  }

  mostrarAviso(message: string) {
    this.toast.show("aviso", "Aviso", message, 4000);
  }

  mensagemSucesso(message: string) {
    this.toast.show("sucesso", "Sucesso", message, 3000);
  }
}
